import Context from "./index";
import React, { useState } from "react";
import request from "Utils/Helper/Request";
import { nairaToKobo } from "Utils/Constant";

const ProductProvider = (props) => {
  const [product, setProduct] = useState({});
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  /** Admin Fetch Products */
  const adminFetchProducts = async (isAirtel = false) => {
    // const baseUrl = isAirtel
    //   ? process.env.REACT_APP_MTN_BASE_API_URL
    //   : process.env.REACT_APP_MTN_BASE_API_URL;
    const baseUrl = process.env.REACT_APP_MTN_BASE_API_URL;
    try {
      const response = await request(`${baseUrl}/admin/product`, {
        method: "GET",
        authType: "accessToken",
      });
      setProducts(response.data);
    } catch (error) {
      throw error;
    }
  };

  /** Admin Fetch Product */
  const adminFetchProduct = async (product_id, isAirtel = false) => {
    try {
      const baseUrl = isAirtel
        ? process.env.REACT_APP_MTN_BASE_API_URL
        : process.env.REACT_APP_MTN_BASE_API_URL;
      const response = await request(`${baseUrl}/admin/product/${product_id}`, {
        method: "GET",
        authType: "accessToken",
      });
      setProduct(response.data);
    } catch (error) {
      throw error;
    }
  };

  /** Admin Create Product */
  const adminCreateProduct = async (
    user_id,
    name,
    type,
    subscription_type,
    amount,
    webhook,
    status,
    validity_days,
    is_free
  ) => {
    try {
      setIsLoading(true);
      const response = await request(
        `${process.env.REACT_APP_MTN_BASE_API_URL}/admin/product/create`,
        {
          method: "POST",
          authType: "accessToken",
          body: {
            user_id: user_id,
            name: name,
            type: type,
            subscription_type: subscription_type,
            amount: nairaToKobo(amount),
            webhook: webhook,
            status: status,
            validity_days: validity_days,
            is_free: is_free,
          },
        }
      );
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      throw error;
    }
  };

  /** Admin Update STatus */
  // extra: optional { force, reason } (admin override when leaving LIVE).
  const adminUpdateStatus = async (product_id, status, extra = {}) => {
    try {
      setIsLoading(true);
      const response = await request(
        `${process.env.REACT_APP_MTN_BASE_API_URL}/admin/product/update/status`,
        {
          method: "POST",
          body: {
            product_id: product_id,
            status: status,
            ...extra,
          },
        }
      );
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      throw error;
    }
  };

  /** Partner Fetch Product */
  const partnerFetchProducts = async (isAirtel = false) => {
    const baseUrl = isAirtel
      ? process.env.REACT_APP_MTN_BASE_API_URL
      : process.env.REACT_APP_MTN_BASE_API_URL;
    try {
      const response = await request(`${baseUrl}/product`, {
        method: "GET",
        authType: "apiKey",
      });
      setProducts(response.data);
    } catch (error) {
      throw error;
    }
  }; /** Partner Fetch Product */
  const partnerFetchProduct = async (product_id, isAirtel = false) => {
    const baseUrl = isAirtel
      ? process.env.REACT_APP_MTN_BASE_API_URL
      : process.env.REACT_APP_MTN_BASE_API_URL;
    try {
      const response = await request(`${baseUrl}/product/${product_id}`, {
        method: "GET",
        authType: "apiKey",
      });
      setProduct(response.data);
    } catch (error) {
      throw error;
    }
  };

  /** Partner Create Product */
  const partnerCreateProduct = async (
    name,
    type,
    subscription_type,
    amount,
    webhook,
    status,
    validity_days
  ) => {
    try {
      setIsLoading(true);
      const response = await request(
        `${process.env.REACT_APP_MTN_BASE_API_URL}/product`,
        {
          method: "POST",
          authType: "apiKey",
          body: {
            name: name,
            type: type,
            subscription_type: subscription_type,
            amount: nairaToKobo(amount),
            webhook: webhook,
            status: status,
            validity_days: validity_days,
          },
        }
      );
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      throw error;
    }
  };

  /** Partner Update Status */
  const partnerUpdateStatus = async (product_id, status) => {
    try {
      setIsLoading(true);
      const response = await request(
        `${process.env.REACT_APP_MTN_BASE_API_URL}/product/update/status`,
        {
          method: "POST",
          authType: "apiKey",
          body: {
            product_id: product_id,
            status: status,
          },
        }
      );
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      throw error;
    }
  };
  return (
    <Context.Provider
      value={{
        ...props,
        isLoading,
        setIsLoading,
        products,
        setProducts,
        product,
        setProduct,
        adminFetchProducts,
        adminFetchProduct,
        adminCreateProduct,
        adminUpdateStatus,
        partnerFetchProducts,
        partnerFetchProduct,
        partnerCreateProduct,
        partnerUpdateStatus,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default ProductProvider;
